import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export { BACKEND_URL };
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kqm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (localStorage.getItem("kqm_mode") === "employee") config.headers["x-acting-as"] = "employee";
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const eur = (n) => {
  const v = Number(n || 0);
  return (v < 0 ? "-€" : "€") + Math.abs(v).toLocaleString("en-IE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${fmtDate(iso)} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export const hrs = (n) => { const m = Math.round(Math.abs(Number(n || 0)) * 60); return `${Number(n) < 0 ? "-" : ""}${Math.floor(m / 60)}:${String(m % 60).padStart(2, "0")}`; };

// Safely preview an uploaded file (image/PDF data-URL or object-storage URL) in a
// new tab without document.write string interpolation (avoids HTML/JS injection).
export function openFilePreview(url, title) {
  const safe = String(url || "");
  if (!/^(data:|https?:|blob:)/i.test(safe)) return false;
  const w = window.open("", "_blank");
  if (!w) return false;
  if (title) w.document.title = title;
  w.document.body.style.margin = "0";
  const f = w.document.createElement("iframe");
  f.src = safe; // set as a property → the browser never parses this as HTML
  f.setAttribute("title", title || "preview");
  f.style.cssText = "position:fixed;inset:0;width:100%;height:100%;border:0";
  w.document.body.appendChild(f);
  return true;
}

export default api;
